import { useState, useEffect } from "react";

import Button from "@mui/material/Button";
import Container from "@mui/material/Container";

const Trial = () => {
  const initialValues = {
    username: "",
    email: "",
    phonenumber: "",
    country: "",
  };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
    // console.log(formValues);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setFormErrors(validate(formValues));
    setIsSubmit(true);
  };
  useEffect(() => {
    console.log(formErrors);
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      // console.log(formValues);
    }
  }, [formErrors]);
  const validate = (values) => {
    const errors = {};
    const regex = /^[a-zA-Z0-9]+@+[a-zA-Z0-9]+.+[A-z]/;
    const numbregex = /^\d{11}$/;
    if (!values.username) {
      errors.username = "Username is required!";
    }
    if (!values.email) {
      errors.email = "Email is required!";
    } else if (!regex.test(values.email)) {
      errors.email = "This is not a valid email format!";
    }
    if (!values.phonenumber) {
      errors.phonenumber = "Phone Number is required!";
    } else if (!numbregex.test(values.phonenumber)) {
      errors.phonenumber = "This is not a valid phonenumber format!";
    }
    if (!values.country) {
      errors.country = "Add Your Country!";
    }

    return errors;
  };
  return (
    <div className="QL__Trial">
      <Container>
        <h1 style={{ textAlign: "center" }} className="HeadingAll py-5">
          Book Free Trial NOW!
        </h1>

        <form onSubmit={handleSubmit} className="form">
          <div className="QL__Trial__form">
            <label htmlFor="username">Name:</label>
            <br />
            <br />

            <input
              className="QL__Tral__formField"
              value={formValues.username}
              onChange={handleChange}
              type="text"
              name="username"
              id="username"
              placeholder="Enter name"
            />
            <div className="pt-2" style={{ fontSize: 16, color: "red" }}>
              {formErrors.username}
            </div>
          </div>
          <div className="QL__Trial__form">
            <label htmlFor="email">Email:</label>
            <br />
            <br />

            <input
              value={formValues.email}
              onChange={handleChange}
              className="QL__Tral__formField"
              type="email"
              name="email"
              id="email"
              placeholder="Email Address"
            />
            <div className="pt-2" style={{ fontSize: 16, color: "red" }}>
              {formErrors.email}
            </div>
          </div>
          <div className="QL__Trial__form">
            <label htmlFor="phone">Phone Number:</label>

            <br />
            <br />
            <input
              className="QL__Tral__formField"
              value={formValues.phonenumber}
              type="number"
              name="phonenumber"
              id="phonenumber"
              placeholder="Phone Number"
              onChange={handleChange}
            />
            <div className="pt-2" style={{ fontSize: 16, color: "red" }}>
              {formErrors.phonenumber}
            </div>
          </div>
          <div className="QL__Trial__form">
            <label htmlFor="country">Country:</label>
            <br />
            <br />

            <input
              value={formValues.country}
              onChange={handleChange}
              className="QL__Tral__formField"
              type="text"
              name="country"
              id="country"
              placeholder="e.g.newyork"
            />
            <div className="pt-2" style={{ fontSize: 16, color: "red" }}>
              {formErrors.country}
            </div>
            <Button
              type="submit"
              className="QL__PG__Registration__buttons1"
              variant="contained"
            >
              Submit
            </Button>
            {Object.keys(formErrors).length === 0 && isSubmit ? (
              <div style={{ fontSize: 32 }} className="pt-5">
                {" "}
                Submitted Successfully
              </div>
            ) : (
              <pre></pre>
            )}
          </div>
          {/* <div style={{textAlign:"center"}} className="pb-5"> */}

          {/* </div> */}
        </form>
      </Container>
    </div>
  );
};
export default Trial;
